export default __webpack_public_path__ + "static/media/029-panda bear.f035d770.svg";